export const JOBSITE_INITIAL_FILTER_FIELDS = ['name', 'description', 'status']
